import React from 'react';
/**
 * OnboardingLayout
 * ------------------------------------------------------------------
 * Shared shell for every onboarding step: fixed left marketing panel
 * (brand, context copy, reassurance note) and a right-hand white
 * card that hosts the actual step content passed in as `children`.
 * A slim dark footer bar runs across the full viewport width.
 */
const OnboardingLayout = ({ children }) => {
  return (
    <div className="amok-onboarding">
      <div className="amok-onboarding__body">
        <aside className="amok-onboarding__panel">
          <div className="amok-onboarding__brand">AMOK.EARTH</div>

          <div className="amok-onboarding__intro">
            <h1 className="amok-onboarding__welcome f24 fw-500">Welcome here</h1>
            <p className="amok-onboarding__lead f18">
              This website is for getting your creative projects done.
              Let&rsquo;s get started by building out your profile.
            </p>
          </div>

          <div className="amok-onboarding__block">
            <h2 className="amok-onboarding__block-title f18 fw-500">Why we ask this</h2>
            <ul className="amok-onboarding__list">
              <li className="f16">Showcase your creative journey</li>
              <li className="f16">Connect you with relevant opportunities and people</li>
              <li className="f16">Unlock insights tailored to your work</li>
            </ul>
          </div>

          <div className="amok-onboarding__block">
            <h2 className="amok-onboarding__block-title f18 fw-500">What you&rsquo;ll add</h2>
            <ul className="amok-onboarding__list">
              <li className="f16">Ongoing creative roles you&rsquo;re currently in</li>
              <li className="f16">Past projects you&rsquo;ve completed</li>
              <li className="f16">Current projects (in progress, not public yet)</li>
              <li className="f16">Future Projects (ideas, yet to even begin!)</li>
            </ul>
          </div>

          <div className="amok-onboarding__note">
            <p className="f20 fw-500 text-white amok-onboarding__note-title">
              Every project you&rsquo;ve worked on <br /> shapes your creative identity.
            </p>
            <p className="amok-onboarding__note-sub text-white">
              This takes ~2&ndash;3 minutes, you can always edit or add more later.
            </p>
          </div>
        </aside>

        <main className="amok-onboarding__card" role="main">
          {children}
        </main>
      </div>
    </div>
  );
};

export default OnboardingLayout;
